define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {

		postProcessSuccess: function() {
			this.inherited(arguments);
			this.widget.set("customViewDirty", false);
			this.widget.refreshDefaultCustomView();
		}
	});
});